module.exports = __webpack_public_path__ + "img/home-solution-shiyou.361a2789.png";